<form #replyCommentForm="ngForm" [ngClass]="{'disabled-content': loadingSpinner}">
	<div class="add-item-block">
		<div class="area-block">
			<textarea #replyCommentTextArea class="text-area reply-text-area" matInput placeholder="Write a comment..." [required]="true"
				minlength="3" type="text" [(ngModel)]="itemDescription" name="itemDescription" [mention]="users"
				[mentionConfig]="{triggerChar:'@', maxItems:25, labelKey:'username', mentionSelect: onMentionSelect}"></textarea>

			<mat-icon class="cancel-item-button" (click)="hideInputItem()">close</mat-icon>
		</div>
		<div class="buttons-block">
			<button mat-button class="add-item-button" (click)="addComment()"
				[ngClass]="{'disabledButton': !replyCommentForm.form.valid}" [disabled]="!replyCommentForm.form.valid">
				<span *ngIf="!loadingSpinner">Add</span>
				<lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
			</button>
		</div>
	</div>
</form>